export interface carouralImagesProps {
    image: string,
    image_alt: string
}

export interface PlanDataProps {
    h2: string,
    pointData: string[],
    h3: string
}

export interface paraContentProps {
    [key: number]: string
}

export const carousalImages: carouralImagesProps[] = [
    {
        image: "https://cdn.buttercms.com/38Kdnz2ITEPaYJV2oIRw",
        image_alt: "A laptop with a wedding budget template open for effective planning."
    },
    {
        image: "https://cdn.buttercms.com/sYQBh1RGiAtld5XvFApv",
        image_alt: "Screenshots from a free wedding budget template showing a variety of wedding expense categories."
    },
    {
        image: "https://cdn.buttercms.com/ABRXmk8SYaNkCsRY1Mqz",
        image_alt: "Table of content outlining expense categories included in a wedding budget template."
    },
]
export const planData:PlanDataProps =
{
    h2: "With this wedding budget template, you'll be able to:",
    pointData: [
        "Track all your wedding expenses in one place",
        "Outline expenses by category to ensure nothing is missed",
        "Keep track of all wedding vendor balances and payment due dates",
        "Live balance of actual budget vs. planned budget",
        "Clear overview of how plans and spending are coming together",
        "Avoid surprise or unnecessary costs"
    ],
    h3: "Outline your wedding budget in one simple, coherent plan",
}

export const paraContent: (string | JSX.Element)[] = [
    "Wedding planning can be overwhelming, especially with various vendors and different types of expenses.",
    <>
        Wedding budgets continue to rise. The{" "}
        <a
            href="https://www.yourweddingatlas.ca/weddings-trends/how-much-does-a-wedding-cost-in-canada/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
        >
            average Canadian wedding costing $32,000,
        </a>{" "}
        meaning it's important that couples have a template or sheet to help stay organized throughout the wedding planning process.
    </>,
    "Callia has created a free wedding budget template to help make tracking your wedding expenses easier than ever. Downloadable as a Google Sheet or Excel Spreadsheet, this free template will make tracking your wedding vendors, actual costs, and finances easy.",
    "Effectively use Callia's budget template by setting a total budget, categorizing expenses, and tracking actual costs to avoid overspending.",
];